var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('Header', {
    attrs: {
      "meta": _vm.meta,
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section')
    }
  }), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "py-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/icon-check-circle.svg")
    }
  }), _vm.finishedPageTitle ? _c('div', {
    staticClass: "mt-3 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.finishedPageTitle))]) : _c('div', {
    staticClass: "mt-3 font-weight-bold"
  }, [_vm._v("預約已成功送出")]), _c('div', {
    staticClass: "mt-3",
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.viewingBookingPreset, 'config.finished_page.content'))
    }
  })]), _c('div', {
    staticClass: "p-3 liff-reservation-form"
  }, [_vm._l(_vm.visiblePages, function (page, index) {
    return _c('div', {
      key: index
    }, [_vm._l(_vm.subjectsOfCurrentPageWithoutSection(page._id), function (subject, i) {
      return _c('b-form-group', {
        key: i,
        staticClass: "mb-3",
        attrs: {
          "label": subject.title,
          "label-cols": "12",
          "label-cols-sm": "6",
          "label-size": "sm",
          "label-for": "input-sm"
        }
      }, [subject.type === 'uploader' ? _c('div', [_c('a', {
        staticClass: "app-file-uploader__current-url text-right",
        attrs: {
          "href": _vm.getFieldValue(subject),
          "target": "_blank"
        }
      }, [_vm.getFieldValue(subject) ? [_c('small', [_vm._v("（查看檔案）")])] : _vm._e()], 2)]) : _c('div', {
        staticClass: "liff-reservation-form__field-value text-right"
      }, [_vm._v(_vm._s(_vm.getFieldValue(subject)))])]);
    }), _vm._l(_vm.sectionsOfCurrentPage(page._id), function (section, i) {
      return [_vm.subjectsOfCurrentSection(section).length > 0 ? _c('b-card', {
        key: "section".concat(i),
        staticClass: "mb-3 liff-reservation-form__card",
        attrs: {
          "header-tag": "header"
        },
        scopedSlots: _vm._u([{
          key: "header",
          fn: function fn() {
            return [_c('div', {
              staticClass: "d-flex justify-content-between align-items-center"
            }, [_c('h6', {
              staticClass: "mb-0"
            }, [_vm._v(_vm._s(section.title))])])];
          },
          proxy: true
        }], null, true)
      }, _vm._l(_vm.subjectsOfCurrentSection(section), function (subject, i) {
        return _c('b-form-group', {
          key: i,
          staticClass: "mb-3",
          attrs: {
            "label": subject.title,
            "label-cols": "12",
            "label-cols-sm": "6",
            "label-size": "sm",
            "label-for": "input-sm"
          }
        }, [subject.type === 'uploader' ? _c('div', [_c('a', {
          staticClass: "app-file-uploader__current-url text-right",
          attrs: {
            "href": _vm.getFieldValue(subject),
            "target": "_blank"
          }
        }, [_vm.getFieldValue(subject) ? [_c('small', [_vm._v("（查看檔案）")])] : _vm._e()], 2)]) : _c('div', {
          staticClass: "liff-reservation-form__field-value text-right"
        }, [_vm._v(_vm._s(_vm.getFieldValue(subject)))])]);
      }), 1) : _vm._e()];
    })], 2);
  }), _c('img', {
    staticClass: "mt-3",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.deepGet(_vm.viewingBookingPreset, 'config.finished_page.banner_image')
    }
  })], 2), _c('div', {
    staticClass: "footer-action-bar"
  }, [_vm.showNextBookingButton ? _c('ShareButton', {
    attrs: {
      "variant": "s-btn-outline-primary"
    },
    on: {
      "click": _vm.handleNextBooking
    }
  }, [_vm._v(" 繼續預約 ")]) : _vm._e(), _vm.showGoBookingListButton ? _c('ShareButton', {
    attrs: {
      "variant": "s-btn-outline-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'LiffBookingPreset',
          params: {
            presetId: _vm.bookingPresetId
          }
        });
      }
    }
  }, [_vm._v(" 預約紀錄 ")]) : _vm._e(), _c('MemberButton', {
    attrs: {
      "button-text": "回 LINE 官方帳號",
      "type": "OA"
    }
  })], 1)])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }